// Returns Tailwind gradient classes based on weather code and day/night
export function getWeatherTheme(weatherCode: number, isDay: boolean): {
  cardBg: string;
  cardBorder: string;
  pageBg: string;
  tempColor: string;
} {
  // Clear sky
  if (weatherCode === 0) {
    if (isDay) {
      return {
        cardBg: "bg-gradient-to-b from-amber-400/25 to-orange-500/20",
        cardBorder: "border-amber-400/20",
        pageBg: "",
        tempColor: "text-amber-100",
      };
    } else {
      return {
        cardBg: "bg-gradient-to-b from-indigo-900/50 to-slate-900/50",
        cardBorder: "border-indigo-400/20",
        pageBg: "",
        tempColor: "text-indigo-100",
      };
    }
  }

  // Mainly clear / partly cloudy (1, 2, 3)
  if (weatherCode <= 3) {
    if (isDay) {
      return {
        cardBg: "bg-gradient-to-b from-sky-400/25 to-blue-500/20",
        cardBorder: "border-sky-400/20",
        pageBg: "",
        tempColor: "text-sky-100",
      };
    } else {
      return {
        cardBg: "bg-gradient-to-b from-slate-700/50 to-slate-900/50",
        cardBorder: "border-slate-500/20",
        pageBg: "",
        tempColor: "text-slate-100",
      };
    }
  }

  // Fog (45, 48)
  if (weatherCode === 45 || weatherCode === 48) {
    return {
      cardBg: "bg-gradient-to-b from-slate-500/30 to-slate-700/30",
      cardBorder: "border-slate-400/20",
      pageBg: "",
      tempColor: "text-slate-200",
    };
  }

  // Rain / drizzle (51-67, 80-82)
  if (
    (weatherCode >= 51 && weatherCode <= 67) ||
    (weatherCode >= 80 && weatherCode <= 82)
  ) {
    return {
      cardBg: "bg-gradient-to-b from-blue-700/30 to-slate-700/30",
      cardBorder: "border-blue-400/20",
      pageBg: "",
      tempColor: "text-blue-100",
    };
  }

  // Snow (71-77, 85-86)
  if (
    (weatherCode >= 71 && weatherCode <= 77) ||
    weatherCode === 85 ||
    weatherCode === 86
  ) {
    return {
      cardBg: "bg-gradient-to-b from-slate-200/20 to-blue-200/20",
      cardBorder: "border-slate-200/30",
      pageBg: "",
      tempColor: "text-slate-100",
    };
  }

  // Thunderstorm (95-99)
  if (weatherCode >= 95) {
    return {
      cardBg: "bg-gradient-to-b from-purple-900/40 to-slate-900/40",
      cardBorder: "border-purple-400/20",
      pageBg: "",
      tempColor: "text-purple-100",
    };
  }

  // Overcast / default
  return {
    cardBg: "bg-gradient-to-b from-slate-600/30 to-slate-800/30",
    cardBorder: "border-slate-400/20",
    pageBg: "",
    tempColor: "text-slate-100",
  };
}

// Page background based on overall conditions
export function getPageBackground(weathers: Array<{ weatherCode: number; isDay: boolean }>): string {
  const hasThunder = weathers.some(w => w.weatherCode >= 95);
  const hasRain = weathers.some(w => (w.weatherCode >= 51 && w.weatherCode <= 82));
  const allClear = weathers.every(w => w.weatherCode <= 3);
  const allDay = weathers.every(w => w.isDay);

  if (hasThunder) return "from-slate-950 via-purple-950 to-slate-950";
  if (hasRain) return "from-slate-950 via-blue-950 to-slate-950";
  if (allClear && allDay) return "from-slate-950 via-blue-900 to-slate-950";
  return "from-slate-950 via-slate-900 to-slate-950";
}
